/* eslint-plugin-disable angular, react */
import React, {Component} from "react";
import {Link, NavLink, withRouter} from "react-router-dom";
import {withTranslate} from 'react-redux-multilingual';
//import ChangeLang from "./../components/ChangeLang";
import {Skull} from "react-loading-skeleton-placeholders";
import {slideInRight} from 'react-animations';
import Radium, {StyleRoot} from 'radium';
import ProgressiveImage from "react-progressive-image-loading";
import ChangeLang from "./ChangeLang";
import {logout} from "../store/actions/userActions";
import {connect} from "react-redux";


const styles = {
    slideInRight: {
        animation: 'x 1s',
        animationName: Radium.keyframes(slideInRight, 'slideInRight')
    },

    zoomIn: {
        animation: 'x 1s',
        animationName: Radium.keyframes(slideInRight, 'zoomIn')
    },
    bounceInLeft: {
        animation: 'x 1s',
        animationName: Radium.keyframes(slideInRight, 'bounceInLeft')
    },
};


class Navigator extends Component {

    logout = (e) => {
        e.preventDefault();
        localStorage.clear();
        this.props.logout();
        //window.location.href = "/login";
    };

    state = {
        showMobileMenu: false
    };


    toggleMobileMenu = (toggle) => {
        this.setState({
            showMobileMenu: toggle
        });

        const body = document.getElementById("body");
        if (toggle === true) {
            body.style.overflow = "hidden";

        } else {
            body.style.overflow = "auto";

        }
    };

    render() {
        const token = localStorage.getItem('access_token');
        if (this.props.mobileMenuIsShown) {
            return (
                <div className="mobile-navigator-wrapper">
                    <div className="bars topnav flex flex-direction-row justify-content-between">
                        <button className="btn-style-less">
                            <NavLink to="/" onClick={() => this.toggleMobileMenu(false)}>
                                <img style={{width: "40px"}} alt="logo" src="/images/logo.png"/>
                            </NavLink>
                        </button>

                        {!this.state.showMobileMenu ?
                            <button className="mobile-icon btn-style-less cursor-pointer"
                                    onClick={() => this.toggleMobileMenu(true)}>
                                <img src="/images/menu.png" alt="menu"/>
                            </button> :
                            <button className="mobile-icon btn-style-less cursor-pointer"
                                    onClick={() => this.toggleMobileMenu(false)}>
                                <img src="/images/close.png" alt="close"/>
                            </button>
                        }
                    </div>

                    <StyleRoot>
                        <div style={styles.bounceInLeft} hidden={!this.state.showMobileMenu}
                             className="mobile-navigator">
                            <ul className="navbar-nav ml-auto">
                                <li className="nav-avatar mb-20">
                                    {this.props.authUser ?
                                        <div>
                                            <NavLink to="/profile"
                                                     onClick={() => this.toggleMobileMenu(false)}
                                                     className="btn-style-less"
                                                     activeClassName="btn-style-less"
                                                     role="button"
                                                     aria-expanded="false">
                                                <strong>
                                                    <ProgressiveImage
                                                        preview={this.props.authUser.image}
                                                        src={this.props.authUser.image}
                                                        render={(src, style) => <img alt="about" src={src}
                                                                                     style={style}/>}
                                                    />
                                                </strong>
                                            </NavLink>
                                            <NavLink to="/profile" activeClassName=""
                                                     onClick={() => this.toggleMobileMenu(false)}><h5
                                                className="white no-margin user-name">{this.props.authUser.name}</h5></NavLink>

                                            <div className="profile-points">
                                                <NavLink to="/profile" onClick={() => this.toggleMobileMenu(false)}
                                                         className="pointer-event-none"
                                                         activeClassName="pointer-event-none"> {this.props.authUser.cash_back + " " + this.props.translate("currency")}</NavLink>

                                            </div>
                                        </div>
                                        : (token ? <div className="nav-skull"><Skull/></div> : null)
                                    }
                                </li>
                                <li className="login-btn" hidden={token}>
                                    <a href="/login" onClick={() => this.toggleMobileMenu(false)}>
                                        <span>{this.props.translate("login")}</span>
                                    </a>
                                </li>
                                {this.props.authUser ?
                                    <li className="capitalized">
                                        <NavLink to={{
                                            pathname: "/my-appointments",
                                            pastReservationRefund: false
                                        }}
                                                 onClick={() => this.toggleMobileMenu(false)}>{this.props.translate("my_appointment")}</NavLink>
                                    </li>
                                    : null}
                                <li>
                                    <li className="nav-item">
                                        <ChangeLang/>
                                    </li>

                                    <NavLink to="/doctors" onClick={() => this.toggleMobileMenu(false)}
                                             className={this.props.match.path.includes("doctor") ? 'nav-link active' : 'nav-link'}>
                                        {
                                            this.props.translate("doctors")
                                        }
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to="/offers" onClick={() => this.toggleMobileMenu(false)}
                                             className={this.props.match.path.includes("offer") ? 'nav-link active' : 'nav-link'}>
                                        {
                                            this.props.translate("offers")
                                        }
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to="/doctor/download" onClick={() => this.toggleMobileMenu(false)}
                                             className={this.props.match.path === "/doctor/download" ? 'nav-link active' : 'nav-link'}>
                                        {
                                            this.props.translate("join_our_doctors")
                                        }
                                    </NavLink>
                                </li>

                                {/*         <li>
                                    <a href="/contact"
                                       className={this.props.match.path === "/contact" ? "nav-link active" : "nav-link"}>
                                        {
                                            this.props.translate("contact")
                                        }
                                    </a>
                                </li>*/}
                                {this.props.authUser ?
                                    <li><a href='/'
                                           onClick={(e) => this.logout(e)}>{this.props.translate("logout")}</a></li>
                                    : null}

                            </ul>
                        </div>
                    </StyleRoot>
                </div>
            )
        } else
            return (
                <nav className="navbar navbar-expand-lg navbar-dark ftco_navbar bg-dark ftco-navbar-light "
                     hidden={this.props.mobileMenuIsShown} id="ftco-navbar">
                    <div className="container pl-15 pr-15">
                        <a className="navbar-brand" href="/">
                            <img src="images/logo.png" alt="seena logo"/>
                        </a>
                        <div id="ftco-nav">
                            <ul className="navbar-nav ml-auto">

                                {/*<li className="nav-item">
                                    <NavLink exact
                                        className={this.props.match.path.indexOf("doctor") !== -1 && this.props.match.path !== "/doctor/download" ? 'nav-link active' : 'nav-link'}
                                        to="/doctors">
                                        {
                                            this.props.translate("doctors")
                                        }
                                    </NavLink>
                                </li>*/}
                                <li className="nav-item">
                                    <NavLink className={this.props.match.path.includes("doctor") ? 'nav-link active' : 'nav-link'} to="/doctors">
                                        {
                                            this.props.translate("doctors")
                                        }
                                    </NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink className={this.props.match.path.includes("offer") ? 'nav-link active' : 'nav-link'} to="/offers">
                                        {
                                            this.props.translate("offers")
                                        }
                                    </NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink className="nav-link" to="/doctor/download">
                                        {
                                            this.props.translate("join_our_doctors")
                                        }
                                    </NavLink>
                                </li>


                                <li className="nav-item">
                                    <ChangeLang/>
                                </li>

                                {
                                    !token ?
                                        <li className="nav-item cta">
                                            <a className="nav-link cta shadow-4d" href="/login">
                                                <span>{this.props.translate("login")}</span>
                                            </a>
                                        </li> :

                                        <li className="nav-item nav-avatar relative">
                                            {this.props.authUser ?
                                                <NavLink to="/"
                                                         className="dropdown-toggle rkanjel-purple-color capitalized btn-style-less"
                                                         data-toggle="dropdown"
                                                         role="button"
                                                         aria-expanded="false">
                                                    <strong className="pull-right user-img">
                                                        <ProgressiveImage
                                                            preview={this.props.authUser.image}
                                                            src={this.props.authUser.image}
                                                            render={(src, style) => <img alt="about" src={src}
                                                                                         style={style}/>}
                                                        />
                                                    </strong>
                                                    <span>{this.props.authUser.name}</span>
                                                </NavLink>
                                                : (token ? <div className="nav-skull"><Skull/></div> : null)
                                            }

                                            <ul className="dropdown-menu capitalized" role="menu">
                                                <li><NavLink to='/profile'>{this.props.translate("profile")}</NavLink>
                                                </li>
                                                <li><NavLink
                                                    to='/my-appointments'>{this.props.translate("my_appointment")}</NavLink>
                                                </li>
                                                <li><a href='/'
                                                       onClick={(e) => this.logout(e)}>{this.props.translate("logout")}</a>
                                                </li>
                                            </ul>
                                        </li>
                                }
                            </ul>
                        </div>
                    </div>
                </nav>
            )
    }

}



const mapStateToProps = (state) => {
    return {
        authUser: state.user.authUser,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        logout: () => {dispatch(logout())},
    }
};



export default withTranslate(withRouter(connect(mapStateToProps, mapDispatchToProps)(Navigator)));